import React, { Component } from "react";

import { api } from "EmployerApplication/urls";
import isIntuit from "Intuit/isIntuit";
import { connect } from "react-redux";
import { reduxForm, formValueSelector } from "redux-form";
import companyToken from "Utils/companyToken";
import fetchWithCSRFToken from "Utils/fetchWithCSRFToken";

import { EDITED_EMPLOYEE } from "../Actions";
import { TitleSmall } from "Cobalt/Header";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "Cobalt/Modal";
import BodyText from "Common/BodyText";
import Button from "Common/Button";
import Icon from "Common/Icon";
import { SizeSwitch } from "Common/Responsive";

import EditEmployeeEmailForm from "./EditEmployeeEmailForm";

export class EditEmployeeEmailModalDumb extends Component {
  handleClose() {
    this.props.reset(this.props.form);
    this.props.onHide();
  }

  renderCancelButton() {
    return (
      <Button className="EditEmployeeModal__secondaryButton" color="gray" onClick={this.handleClose.bind(this)} size={isIntuit() ? "medium" : undefined} mr={2}>
        Cancel
      </Button>
    );
  }

  renderFooter() {
    let content = null;
    if (this.props.submitSucceeded) {
      content = (
        <Button onClick={this.handleClose.bind(this)} size={isIntuit() ? "medium" : undefined}>
          Finish
        </Button>
      );
    } else {
      content = (
        <>
          <SizeSwitch xs={isIntuit() ? null : this.renderCancelButton()} sm={this.renderCancelButton()} />

          {this.props.submitting ? (
            <Button disabled size={isIntuit() ? "medium" : undefined}>
              <Icon icon="cog" spin mr={3} flavor="solid" />
              Loading...
            </Button>
          ) : (
            <Button id="updateButton" onClick={this.props.handleSubmit} disabled={this.props.invalid} size={isIntuit() ? "medium" : undefined}>
              Update
            </Button>
          )}
        </>
      );
    }
    return (
      <SizeSwitch
        xs={isIntuit() ? <ModalFooter className="Modal__Footer--intuit-center">{content}</ModalFooter> : <ModalFooter>{content}</ModalFooter>}
        sm={<ModalFooter>{content}</ModalFooter>}
      />
    );
  }

  render() {
    const { employee } = this.props;
    let modalBody;
    const employeeFullName = employee ? employee.full_name.replace(/^\s+|\s+$/g, "") : "this employee";

    if (this.props.submitSucceeded) {
      modalBody = (
        <ModalBody>
          <TitleSmall mt={0} mb={0}>
            Success!
          </TitleSmall>
          <BodyText>
            <p> You've successfully edited "{employeeFullName}" email address!</p>
          </BodyText>
        </ModalBody>
      );
    } else {
      modalBody = (
        <ModalBody>
          <EditEmployeeEmailForm employeeFullName={employeeFullName} canLinkAccount={false} />
        </ModalBody>
      );
    }

    return (
      <Modal show={this.props.show} onHide={this.handleClose.bind(this)} className="EditEmployeeModal">
        <ModalHeader closeButton>
          <TitleSmall mt={0} mb={0}>
            Edit Email
          </TitleSmall>
        </ModalHeader>
        {modalBody}
        {this.renderFooter()}
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const selector = formValueSelector(ownProps.form);
  const { employee } = ownProps;

  return {
    employees: state.employees,
    employeeEmail: selector(state, "employee[email]"),
    initialValues: {
      employee,
    },
  };
};

const withReduxForm = reduxForm({
  enableReinitialize: true,
  onSubmit: (values, dispatch, props) =>
    fetchWithCSRFToken(api.updateEmployee, {
      method: "PUT",
      body: JSON.stringify({
        employee_hash_id: props.employee.hash_id,
        employee: values.employee,
        company_id_token: companyToken(),
      }),

      processData: false,
    })
      .then((response) => response.json())
      .then((response) => {
        dispatch({ type: EDITED_EMPLOYEE, employee: response });
      }),
});

const withRedux = connect(mapStateToProps);

export default withRedux(withReduxForm(EditEmployeeEmailModalDumb));
